export default __webpack_public_path__ + "static/precision-d589dc1bf8b60ac9cbe868acaf48ef55.png";